import { composeUrlObjectFromURL, URLEncode } from 'adaguc-webmapjs';
import { getWMJSLayerById } from '@adaguc/react-webmapjs';
import axios from 'axios';
import moment from 'moment';

export const GetFeatureInfo = (flatLayer, options, webMapJSInstance, selectedSPITime) => {
  return new Promise((resolve, reject) => {
    if (!webMapJSInstance) {
      console.error('no wmjsinstance');
      return;
    }
    if (!moment(selectedSPITime).isValid()) {
      reject(new Error('GetFeatureInfo requires a valid selectedSPITime, received: "' + selectedSPITime + '"'));
      return;
    }
    console.log(selectedSPITime);
    const queryDateStart = (moment(selectedSPITime).subtract(1, 'years')).toISOString();
    const queryDateStop = (moment(selectedSPITime).add(15, 'days')).toISOString();
    let currentOptions = {};
    currentOptions.x = options.x;
    currentOptions.y = options.y;
    currentOptions.set = true;
    const wmjsLayer = getWMJSLayerById(flatLayer.id);
    let gfiUrl = webMapJSInstance.getWMSGetFeatureInfoRequestURL(wmjsLayer, options.x, options.y);
    let urlObject = composeUrlObjectFromURL(gfiUrl);
    let GFIURL = urlObject.location + '?';
    for (let key in urlObject.kvp) {
      let value = urlObject.kvp[key];
      if (key === 'info_format') value = 'application/json';
      if (key === 'time') value = queryDateStart + '/' + queryDateStop;
      if (key === 'dim_member')value = '*';
      if (key === 'dim_member')value = '*';
      if (key === 'dim_percentile')value = '*';
      GFIURL += (key + '=' + URLEncode(value)) + '&';
    }

    axios({
      method: 'get',
      url: GFIURL,
      responseType: 'json'
    }).then(src => {
      resolve(src.data);
    }).catch((e) => {
      console.error(e);
      reject(e);
    });
  });
};
